import { ChangeDetectionStrategy, Component, QueryList, ViewChildren } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { MenuSharedFacade, TrainingSharedFacade } from '@medsurf/flat-facades';
import { BaseQuestionComponent } from './question-types/base-question.component';

@Component({
    selector: 'medsurf-questions',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
    standalone: false
})
export class QuestionsComponent {
  /**
   * Exports
   */
  public readonly FlatModels = FlatModels;
  
  /**
   * View Children
   */
  @ViewChildren('questionComponent') public questionComponents: QueryList<BaseQuestionComponent<FlatModels.QuestionEntityModels.QuestionEntityType, FlatModels.TrainingSharedModels.TrainingResultType>>;

  /**
   * Constructor
   *
   * @param menuSharedFacade
   * @param trainingSharedFacade
   */
  public constructor(public menuSharedFacade: MenuSharedFacade,
                     public trainingSharedFacade: TrainingSharedFacade) {
  }

  /**
   * Set Show Feedback
   *
   * @param trainingPage
   */
  public setShowFeedback(trainingPage: FlatModels.PageEntityModels.Training | FlatModels.PageEntityModels.Slide) {
    this.questionComponents.forEach(qc => {
      if (qc.footer) {
        qc.footer.setShowFeedback(trainingPage);
      }
    });
  }

  /**
   * Toggle Show Explanation
   */
  public toggleShowExplanation() {
    this.questionComponents.forEach(qc => {
      if (qc.footer) {
        qc.footer.toggleShowExplanation();
      }
    });
  }
}
